export default {
    TRADERA: 'https://www.tradera.com'
};
